import { PureComponent } from "react";

class YouTubeSquare extends PureComponent {
  render() {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19 4H3C1.89543 4 1 4.89543 1 6V16C1 17.1046 1.89543 18 3 18H19C20.1046 18 21 17.1046 21 16V6C21 4.89543 20.1046 4 19 4Z"
          fill="#CC0000"
        />
        <path
          d="M21 6H5C3.89543 6 3 6.89543 3 8V18C3 19.1046 3.89543 20 5 20H21C22.1046 20 23 19.1046 23 18V8C23 6.89543 22.1046 6 21 6Z"
          fill="url(#paint0_linear_3833_25441)"
        />
        <path
          d="M14.9667 12.6C15.2333 12.8 15.2333 13.2 14.9667 13.4L12.3 15.4C11.9704 15.6472 11.5 15.412 11.5 15V11C11.5 10.5879 11.9704 10.3527 12.3 10.6L14.9667 12.6Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3833_25441"
            x1="10.1429"
            y1="18"
            x2="17.3606"
            y2="3.27001"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF0000" />
            <stop offset="1" stopColor="#FF8B8B" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}

export default YouTubeSquare;
